import type { OperationalErrorOptions } from "./operational";
import { OperationalError } from "./operational";

class NotFoundError extends OperationalError {
  constructor(options?: OperationalErrorOptions) {
    super(options);
    this.message = "Object not found.";
  }
}

export { NotFoundError };
